import styled from "styled-components";

import { getOpacityColor, grayScale, pink } from "@enkor/design/colors";
import { Typo } from "@enkor/design/components";
import { removeScrollbar } from "@enkor/design/mixins";
import BaseBottomSheet from "@domains/common/views/modal/BaseBottomSheet/BaseBottomSheet";

const HEADER_HEIGHT = 40;

export const BottomSheetContainer = styled(BaseBottomSheet)`
  width: 100%;
  height: 80vh;
  min-height: 270px;
  max-height: 590px;
  padding: 16px;
  border: 1px solid ${grayScale.main};
  border-radius: 16px 16px 0px 0px;

  background-color: ${grayScale[300]};
`;

export const HeaderWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  height: ${HEADER_HEIGHT}px;
  padding: 8px 0 10px;
`;

export const ScrollWrapper = styled.div`
  display: flex;
  flex-direction: column;
  overflow-y: auto;

  height: calc(100% - ${HEADER_HEIGHT}px);

  /* 스크롤바 전체 스타일 */

  &::-webkit-scrollbar {
    width: 4px; /* 스크롤바의 너비 */
    height: 12px;
  }

  /* 스크롤바 트랙(경로) 스타일 */

  &::-webkit-scrollbar-track {
    background-color: ${grayScale[100]}; /* 스크롤바 트랙의 배경 색상 */
  }

  /* 스크롤바 핸들(이동하는 부분) 스타일 */

  &::-webkit-scrollbar-thumb {
    border: none; /* 스크롤바 핸들의 테두리 (트랙과 같은 색상으로 설정하여 핸들만 보이게) */
    border-radius: 6px; /* 스크롤바 핸들의 모서리 둥글기 */

    background-color: ${grayScale.white}; /* 스크롤바 핸들의 배경 색상 */
  }

  /* 스크롤바 핸들:hover 스타일 */

  &::-webkit-scrollbar-thumb:hover {
    background: ${grayScale.white}; /* 스크롤바 핸들의 배경 색상 (hover 시) */
  }
`;

export const Title = styled(Typo.Text)`
  color: ${grayScale.white};
`;

export const CancelButton = styled.button`
  color: ${grayScale.white};
  font-weight: 600;
  font-size: 16px;
  line-height: 22px;
`;

export const TextareaWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;

  width: 100%;
  padding: 24px 0 40px;
`;

export const TextareaDescription = styled(Typo.Text)`
  color: ${grayScale.white};
`;

export const ReasonTextarea = styled.textarea`
  width: 100%;
  height: 200px;
  padding: 10px;
  border: 1px solid ${grayScale.main};
  border-radius: 8px;

  background-color: ${getOpacityColor(grayScale.black, 0.2)};

  color: ${grayScale.white};
  font-weight: 400;
  font-size: 16px;
  line-height: 26px;

  resize: none;

  &:focus {
    border: 1px solid ${grayScale.white};
  }

  &::placeholder {
    color: ${grayScale.main};
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
  }

  ${removeScrollbar}
`;

export const SubmitButton = styled.button`
  width: 100%;
  margin-top: auto;
  padding: 13px 0;
  border-radius: 8px;

  background-color: ${pink.main};

  color: ${grayScale.white};
  font-weight: 600;
  font-size: 16px;
  line-height: 22px;

  transition: all 0.3s ease-in-out;

  &:disabled {
    background-color: ${grayScale.main};

    color: ${grayScale[500]};

    cursor: default;
  }
`;
